module.exports = __webpack_public_path__ + "static/ourStoryHomeBG.cb6206e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ourStoryHomeBG.jpg
// module id = 846
// module chunks = 35783957827783